import { ExportDataIcon } from "../../../images";
import { CustomButton } from "../../CustomButton";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import {
  useGeneratePlaybookPDFMutation,
  useLazyGetPlaybookQuery,
} from "../../../../api";
import { CircularProgress } from "@mui/material";
import { useAppSelector } from "../../../../hooks";
import { selectPermissions } from "../../../../features/permissionsSlice";
import { PlaybookPlanNames } from "../../../../types/enums";
import { ReuseTooltip } from "../../ReuseTooltip";

export const ExportPlaybookBtn = ({
  member_id,
  onClose,
  btnHeight = "42px",
  btnPadding = "8px",
  campaign_id,
}: {
  member_id: string;
  campaign_id: string;
  onClose?: () => void;
  btnHeight?: string;
  btnPadding?: string;
}) => {
  const [getPlaybook, { isFetching: isPlaybookLoading }] =
    useLazyGetPlaybookQuery();
  const [generatePlaybookPDF, { isLoading: isGeneratingPlaybookPDF }] =
    useGeneratePlaybookPDFMutation();

  const { isAllowedExportPlaybooks } = useAppSelector(selectPermissions);

  const handleClose = () => {
    onClose && onClose();
  };

  const exportPlaybook = () => {
    getPlaybook({ member_id })
      .unwrap()
      .then((topics) => {
        generatePlaybookPDF({ member_id, topics, campaign_id })
          .unwrap()
          .then((blob) => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${PlaybookPlanNames.playbook} for ${topics.lead_company} - ${topics.lead_name}.pdf`;
            a.click();
            URL.revokeObjectURL(url);
            handleClose();
          })
          .catch((err) => {
            toast.error(
              <CustomToast
                type={"error"}
                text={
                  getErrorMessage(err).globalError ||
                  "Something went wrong. Please try again"
                }
                title={`Failed to generate ${PlaybookPlanNames.playbook} PDF`}
              />,
            );
          });
      })
      .catch((err) =>
        toast.error(
          <CustomToast
            type="error"
            title="Something went wrong"
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
          />,
        ),
      );
  };

  return (
    <ReuseTooltip text={`Export ${PlaybookPlanNames.playbook} (PDF)`}>
      <CustomButton
        onClick={exportPlaybook}
        variant="outlined"
        customColor="#FFFFFF"
        textColor="#1D3E70"
        type="button"
        customSize="fit"
        style={{ padding: btnPadding }}
        sx={{
          borderColor: "#1D3E70",
          minWidth: "fit-content",
          height: btnHeight,
        }}
        disabled={
          isPlaybookLoading ||
          isGeneratingPlaybookPDF ||
          !isAllowedExportPlaybooks
        }
      >
        {isPlaybookLoading || isGeneratingPlaybookPDF ? (
          <CircularProgress size={24} sx={{ color: "#1C3C6C" }} />
        ) : (
          <ExportDataIcon
            color={!isAllowedExportPlaybooks ? "#A5B2C6" : "#1D3E70"}
          />
        )}
      </CustomButton>
    </ReuseTooltip>
  );
};
